import * as angular from "angular";
import {$agreementsFactory} from "./$agreements.factory";


angular
  .module('bringoz.admin.agreements')
  .config(AgreementConfig);


/* @ngInject */
function AgreementConfig($stateProvider) {


  $stateProvider
    .state('agreement', {
      parent: 'bringoz.site',
      url: '/administration/agreements',
      template: '<agreements-view agreements="agreements"></agreements-view>',
      controller: function (triBreadcrumbsService, $scope, agreements, site) {

        $scope.agreements = agreements;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Terms and Conditions"});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});

      },
      resolve: {
        agreements: function($agreements: $agreementsFactory, site) {
          var agreementsRef = $agreements();
          return agreementsRef.$getAll()
            .then((ids:string[]) => {
              return agreementsRef.$asyncValues(ids);
            })
        }
      }
    });

}
